var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnFernwaerme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.95 56.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#4b4a4a;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7px}.cls-2{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.98 43.84v6.76"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.98,
    cy: 53.1,
    r: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.47 53.1h19.61M4.87 53.1h19.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.85 43.84H53.1M31.21 43.84h-8.47M19.23 37.78h-8.47M3.96 11.7h46.03M7.83 43.84V11.7M46.05 43.84V11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.98.85 3.96 11.7M26.98.85 49.99 11.7M12.01 17.14h5.97v7.46h-5.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.23 24.6h-8.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.99 17.14h5.97v7.46h-5.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.21 24.6h-8.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.97 17.14h5.97v7.46h-5.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.19 24.6h-8.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.01 30.32h5.97v7.46h-5.97zM23.99 30.32h5.97v13.52h-5.97zM35.97 30.32h5.97v7.46h-5.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.19 37.78h-8.47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFernwaerme);
export default __webpack_public_path__ + "static/media/icn-fernwaerme.8fbfe374ff172307d239a9e4bbc63dbd.svg";
export { ForwardRef as ReactComponent };